import EventHubMixin from '@/mixins/EventHub.js'
import SizesMixin from '@/mixins/Sizes.js'

export default
{
    name: 'app-header-trigger',

    mixins:
    [
        EventHubMixin,
        SizesMixin
    ],

    data()
    {
        return {
            state: 'list' // 'list' | 'close' | 'hidden'
        }
    },

    watch:
    {
        $route()
        {
            this.setState({ state: 'list', to: { name: `${this.$route.meta.lang}_menu` } })
        }
    },

    created()
    {
        if(this.state === 'list' && this.sizes.width >= 1024)
        {
            this.state = 'hidden'
        }

        this.to = { name: `${this.$route.meta.lang}_menu` }
        this.event = null
        this.back = null
        this.prevData = null
        this.currentData = { state: 'list', to: this.to }
    },

    mounted()
    {
        this.$eventHub.$on('headerTrigger.setState', this.setState)
        this.$eventHub.$on('headerTrigger.prevState', this.prevState)

        document.addEventListener('keydown', (event) =>
        {
            if(event.keyCode === 27 && this.state === 'close')
            {
                event.preventDefault()
                this.onClick()
            }
        })
    },

    methods:
    {
        setState(data)
        {
            this.prevData = this.currentData
            this.currentData = data

            if(data.state === 'list' && this.sizes.width >= 1024)
            {
                data.state = 'hidden'
            }

            this.state = data.state
            this.to = data.to ? data.to : null
            this.event = data.event ? data.event : null
            this.back = data.back ? data.back : null
        },

        prevState()
        {
            if(this.prevData)
            {
                this.setState(this.prevData)
            }
        },

        onClick()
        {
            // Don't do anything
            if(this.state === 'hidden')
            {
                return
            }

            // Trigger event
            if(this.event)
            {
                this.$eventHub.$emit('headerTrigger.click', this.event)
            }

            // Router to
            else if(this.to)
            {
                this.$router.push(this.to)
            }

            // Router back
            else if(this.back)
            {
                console.log(this.$root.$previousRoute)
                this.$router.go(- 1)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-header-trigger/script.js